import LookUpModel from "./LookUpModel";

export default class AdministrativeCategoryModel extends LookUpModel {
    constructor(data: Partial<AdministrativeCategoryModel>) {
        super(data);

        this.update(data);
    }
}
